import { getAuth } from 'firebase/auth';
import { useEffect, useRef, useState } from 'react';

export const useIsFirebaseAuthStateReady = () => {
  const [isReady, setIsReady] = useState(false);
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    const waitForFirebaseAuthStateReady = async () => {
      await getAuth().authStateReady();
      if (isMountedRef.current) {
        setIsReady(true);
      }
    };

    waitForFirebaseAuthStateReady();

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return isReady;
};
